var Builder = Formio.Utils.builder;
export default [
    {
        key: 'once',
        label: 'Once',
        components: [
            {
                type: 'textfield',
                label: 'Frequency label',
                key: 'frequency_once_label',
                tooltip: 'Set the label for this frequency',
                input: true,
                defaultValue: 'Once',
                weight: 1,
            },
            {
                type: 'datagrid',
                input: true,
                label: 'Amounts',
                key: 'amounts_once',
                tooltip: 'The radio button values that can be picked for this field. Values are text submitted with the form data. Labels are text that appears next to the radio buttons on the form.',
                weight: 10,
                reorder: true,
                defaultValue: [{
                        label: '',
                        value: ''
                    }],
                components: [{
                        label: 'Label',
                        key: 'label',
                        input: true,
                        type: 'textfield'
                    }, {
                        label: 'Amount (in cents)',
                        key: 'value',
                        input: true,
                        type: 'number',
                        allowCalculateOverride: false,
                        validate: {
                            required: false
                        }
                    }]
            },
            {
                key: 'amounts_once_default_amount',
                type: 'select',
                label: 'Default amount',
                tooltip: 'Set the default amount for this frequency',
                dataSrc: 'custom',
                template: '<span>{{ item.label }}</span>',
                valueProperty: 'value',
                data: {
                    custom: function custom(ctx) {
                        return ctx.data.amounts_once;
                    }
                },
            },
            {
                type: 'number',
                label: 'Minimum amount `other` (in cents)',
                key: 'amounts_once_min_amount_other',
                tooltip: 'Set a minimum value for amount `other` (in cents). For example:\n\n200 is € 2,-',
                input: true,
                allowCalculateOverride: 1,
            },
            {
                type: 'number',
                label: 'Maximum amount `other` (in cents)',
                key: 'amounts_once_max_amount_other',
                tooltip: 'Set a maximum value for amount `other` (in cents). For example:\n\n5000 is € 50,-',
                input: true,
                allowCalculateOverride: 1,
            },
        ]
    },
    {
        key: 'monthly',
        label: 'Monthly',
        components: [
            {
                type: 'textfield',
                label: 'Frequency label',
                key: 'frequency_monthly_label',
                tooltip: 'Set the label for this frequency',
                input: true,
                defaultValue: 'Monthly',
                weight: 1,
            },
            {
                type: 'datagrid',
                input: true,
                label: 'Amounts',
                key: 'amounts_monthly',
                tooltip: 'The radio button values that can be picked for this field. Values are text submitted with the form data. Labels are text that appears next to the radio buttons on the form.',
                weight: 10,
                reorder: true,
                defaultValue: [{
                        label: '',
                        value: ''
                    }],
                components: [{
                        label: 'Label',
                        key: 'label',
                        input: true,
                        type: 'textfield'
                    }, {
                        label: 'Amount (in cents)',
                        key: 'value',
                        input: true,
                        type: 'number',
                        allowCalculateOverride: false,
                        validate: {
                            required: false
                        }
                    }]
            },
            {
                key: 'amounts_monthly_default_amount',
                type: 'select',
                label: 'Default amount',
                tooltip: 'Set the default amount for this frequency',
                dataSrc: 'custom',
                template: '<span>{{ item.label }}</span>',
                valueProperty: 'value',
                data: {
                    custom: function custom(ctx) {
                        return ctx.data.amounts_monthly;
                    }
                },
            },
            {
                type: 'number',
                label: 'Minimum amount `other` (in cents)',
                key: 'amounts_monthly_min_amount_other',
                tooltip: 'Set a minimum value for amount `other` (in cents). For example:\n\n300 is € 3,-',
                input: true,
                allowCalculateOverride: 1,
            },
            {
                type: 'number',
                label: 'Maximum amount `other` (in cents)',
                key: 'amounts_monthly_max_amount_other',
                tooltip: 'Set a maximum value for amount `other` (in cents). For example:\n\n5000 is € 50,-',
                input: true,
                allowCalculateOverride: 1,
            },
        ]
    },
    {
        key: 'quarterly',
        label: 'Quarterly',
        components: [
            {
                type: 'textfield',
                label: 'Frequency label',
                key: 'frequency_quarterly_label',
                tooltip: 'Set the label for this frequency',
                input: true,
                defaultValue: 'Quarterly',
                weight: 1,
            },
            {
                type: 'datagrid',
                input: true,
                label: 'Amounts',
                key: 'amounts_quarterly',
                tooltip: 'The radio button values that can be picked for this field. Values are text submitted with the form data. Labels are text that appears next to the radio buttons on the form.',
                weight: 10,
                reorder: true,
                defaultValue: [{
                        label: '',
                        value: ''
                    }],
                components: [{
                        label: 'Label',
                        key: 'label',
                        input: true,
                        type: 'textfield'
                    }, {
                        label: 'Amount (in cents)',
                        key: 'value',
                        input: true,
                        type: 'number',
                        allowCalculateOverride: false,
                        validate: {
                            required: false
                        }
                    }]
            },
            {
                key: 'amounts_quarterly_default_amount',
                type: 'select',
                label: 'Default amount',
                tooltip: 'Set the default amount for this frequency',
                dataSrc: 'custom',
                template: '<span>{{ item.label }}</span>',
                valueProperty: 'value',
                data: {
                    custom: function custom(ctx) {
                        return ctx.data.amounts_quarterly;
                    }
                },
            },
            {
                type: 'number',
                label: 'Minimum amount `other` (in cents)',
                key: 'amounts_quarterly_min_amount_other',
                tooltip: 'Set a minimum value for amount `other` (in cents). For example:\n\n400 is € 4,-',
                input: true,
                allowCalculateOverride: 1,
            },
            {
                type: 'number',
                label: 'Maximum amount `other` (in cents)',
                key: 'amounts_quarterly_max_amount_other',
                tooltip: 'Set a maximum value for amount `other` (in cents). For example:\n\n5000 is € 50,-',
                input: true,
                allowCalculateOverride: 1,
            },
        ]
    },
    {
        key: 'yearly',
        label: 'Yearly',
        components: [
            {
                type: 'textfield',
                label: 'Frequency label',
                key: 'frequency_yearly_label',
                tooltip: 'Set the label for this frequency',
                input: true,
                defaultValue: 'Yearly',
                weight: 1,
            },
            {
                type: 'datagrid',
                input: true,
                label: 'Amounts',
                key: 'amounts_yearly',
                tooltip: 'The radio button values that can be picked for this field. Values are text submitted with the form data. Labels are text that appears next to the radio buttons on the form.',
                weight: 10,
                reorder: true,
                defaultValue: [{
                        label: '',
                        value: ''
                    }],
                components: [{
                        label: 'Label',
                        key: 'label',
                        input: true,
                        type: 'textfield'
                    }, {
                        label: 'Amount (in cents)',
                        key: 'value',
                        input: true,
                        type: 'number',
                        allowCalculateOverride: false,
                        validate: {
                            required: false
                        }
                    }]
            },
            {
                key: 'amounts_yearly_default_amount',
                type: 'select',
                label: 'Default amount',
                tooltip: 'Set the default amount for this frequency',
                dataSrc: 'custom',
                template: '<span>{{ item.label }}</span>',
                valueProperty: 'value',
                data: {
                    custom: function custom(ctx) {
                        return ctx.data.amounts_yearly;
                    }
                },
            },
            {
                type: 'number',
                label: 'Minimum amount `other` (in cents)',
                key: 'amounts_yearly_min_amount_other',
                tooltip: 'Set a minimum value for amount `other` (in cents). For example:\n\n200 is € 2,-',
                input: true,
                allowCalculateOverride: 1,
            },
            {
                type: 'number',
                label: 'Maximum amount other (in cents)',
                key: 'amounts_yearly_max_amount_other',
                tooltip: 'Set a maximum value for amount `other` (in cents). For example:\n\n10000 is € 100,-',
                input: true,
                allowCalculateOverride: 1,
            },
        ]
    },
];
